/**
 * UI Reducer for Data Adjustments Page
 * Manages all UI state with typed actions
 */

import { AdjustmentsUIState, AdjustmentsUIAction } from '../types/dataAdjustments.types';

/**
 * Initial UI state
 */
export const initialUIState: AdjustmentsUIState = {
  currentStep: 1,
  completedSteps: [],
  isNameModalOpen: false,
  saveDataName: '',
  errorMessage: null,
  errorPersistent: false,
  errorCode: null,
  errorSuggestion: null,
  successMessage: null,
  isSaving: false,
  isProcessing: false,
  showFileUpload: true,
  showActionButtons: true,
  currentFileIndex: 0,
  originalDataName: '',
  originalFileName: ''
};

/**
 * UI Reducer function
 */
export const uiReducer = (state: AdjustmentsUIState, action: AdjustmentsUIAction): AdjustmentsUIState => {
  switch (action.type) {
    case 'SET_STEP':
      return { ...state, currentStep: action.payload };
      
    case 'MARK_STEP_COMPLETED':
      return {
        ...state,
        completedSteps: state.completedSteps.includes(action.payload)
          ? state.completedSteps
          : [...state.completedSteps, action.payload]
      };
      
    case 'TOGGLE_MODAL':
      return { ...state, isNameModalOpen: action.payload };
      
    case 'SET_SAVE_NAME':
      return { ...state, saveDataName: action.payload };
      
    case 'SET_ERROR': {
      const payload = action.payload;
      if (payload === null || typeof payload === 'string') {
        return {
          ...state,
          errorMessage: payload,
          errorPersistent: false,
          errorCode: null,
          errorSuggestion: null,
          successMessage: null,
        };
      }
      return {
        ...state,
        errorMessage: payload.message,
        errorPersistent: payload.persistent === true,
        errorCode: payload.code ?? null,
        errorSuggestion: payload.suggestion ?? null,
        successMessage: null,
      };
    }

    case 'SET_SUCCESS':
      return {
        ...state,
        successMessage: action.payload,
        errorMessage: null,
        errorPersistent: false,
        errorCode: null,
        errorSuggestion: null,
      };
      
    case 'SET_SAVING':
      return { ...state, isSaving: action.payload };
      
    case 'SET_PROCESSING':
      return { 
        ...state, 
        isProcessing: action.payload,
        showFileUpload: !action.payload,
        showActionButtons: !action.payload 
      };
      
    case 'SHOW_FILE_UPLOAD':
      return { ...state, showFileUpload: action.payload };
      
    case 'SHOW_ACTION_BUTTONS':
      return { ...state, showActionButtons: action.payload };
      
    case 'SET_FILE_INDEX':
      return { ...state, currentFileIndex: action.payload };
      
    case 'SET_ORIGINAL_DATA_NAME':
      return { ...state, originalDataName: action.payload };
      
    case 'SET_ORIGINAL_FILE_NAME':
      return { ...state, originalFileName: action.payload };
      
    case 'RESET_UI':
      return initialUIState;
      
    default:
      return state;
  }
};
